@if (state.loading()) {
  <div class="flex flex-col justify-center items-center pt-20">
    <div class="w-2/12 min-w-64">
      <app-logo-component />
    </div>
    <p>{{ message() }}</p>
    <p-toast key="layout-toast" (onClose)="onToastClose($event)"></p-toast>
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" aria-label="Caricamento" />
  </div>
} @else {
  <div class="layout-wrapper" [ngClass]="containerClass">
    <app-top-bar-component></app-top-bar-component>
    <!-- No sidebar for an account that cannot use the platform: every entry in
         it leads somewhere they are not allowed. The layout-no-sidebar class
         drops the 22rem gutter the static menu reserves, otherwise the panel
         would sit beside an empty column. -->
    @if (canAccessPlatform()) {
      <app-sidebar-component></app-sidebar-component>
    }
    <div class="layout-main-container">
      <p-toast key="layout-toast" (onClose)="onToastClose($event)"></p-toast>
      <div class="layout-main">
        <div class="flex flex-col">
          <div class="layout-page relative">
            <app-desktop-wrapper>
              <app-role-gate>
              <div class="layout-page-header backdrop-blur-lg sticky top-16" [ngClass]="{'empty': empty}">
                <div class="layout-page-header-kpis">
                  @if (tplKPIs) {
                    <div class="flex flex-row">
                      <ng-container [ngTemplateOutlet]="tplKPIs"></ng-container>
                    </div>
                  }
                </div>
                <div class="layout-page-header-other">
                  <div>@if (hasBreadcrumbs) {
                    <p-breadcrumb styleClass="!bg-transparent" [home]="home" [model]="breadcrumbs" /><br />
                  }</div>
                  <div>@if (tplActions) {
                    <ng-container [ngTemplateOutlet]="tplActions"></ng-container>
                  }</div>
                </div>
              </div>
              <div class="layout-page-header-info">
                @if (tplHeader) {
                  <ng-container [ngTemplateOutlet]="tplHeader"></ng-container>
                }
              </div>
              <router-outlet></router-outlet>
              </app-role-gate>
            </app-desktop-wrapper>
          </div>
        </div>
      </div>
      <app-footer-component></app-footer-component>
    </div>
    <app-media-viewer-dialog />
    <div class="layout-mask animate-fadein"></div>
  </div>
}
